interface IofferReversal {
  rollbackSuceeded: boolean;
  remarks: string | null;
}

export const offerReversalTransformer = (response: IofferReversal) => ({
  rollbackSuceeded: response.rollbackSuceeded || false,
  remarks: response.remarks || "",
});
